import React, {memo} from "react";
import utils from "../../utils";
import "./index.scss";

interface iPagination {
  page: number;
  totalPages: number;
  onPaginate: (page: number) => void;
}

const Pagination = ({page = 1, totalPages, onPaginate}: iPagination) => {
  // ============================ Value Validations =================================

  if (totalPages < 0) return null;

  return (
    <ul id="custom-pagination">
      {/* <li className='last-page' onClick={() => setIsOpen(!isOpen)} ref={selectedLimitRef}>
        <CustomDropdownLimit isOpen={isOpen} onChange={onChangeLimit} />
      </li> */}
      {page >= 3 && (
        <li className="first" onClick={() => onPaginate(1)}>
          {utils.convertNumbers2English("1")}
        </li>
      )}
      {page >= 4 && (
        <li className="first" style={{cursor: "not-allowed"}}>
          {"..."}
        </li>
      )}
      {page - 2 !== 1 && page - 1 > 1 && (
        <li className="prev-page mobile" onClick={() => onPaginate(page - 2)}>
          {utils.convertNumbers2English(String(page - 2))}
        </li>
      )}
      {page > 1 && (
        <li className="prev-page" onClick={() => onPaginate(page - 1)}>
          {utils.convertNumbers2English(String(page - 1))}
        </li>
      )}
      <li className="current-page active" onClick={() => onPaginate(page)}>
        {page}
      </li>
      {page < totalPages && (
        <li className="next-page" onClick={() => onPaginate(page + 1)}>
          {utils.convertNumbers2English(String(page + 1))}
        </li>
      )}
      {page + 1 < totalPages && (
        <li className="next-page mobile" onClick={() => onPaginate(page + 2)}>
          {utils.convertNumbers2English(String(page + 2))}
        </li>
      )}
      {page + 4 <= totalPages && (
        <li className="last-page" style={{cursor: "not-allowed"}}>
          {"..."}
        </li>
      )}
      {page + 3 <= totalPages && (
        <li className="last-page" onClick={() => onPaginate(totalPages)}>
          {utils.convertNumbers2English(String(totalPages))}
        </li>
      )}
    </ul>
  );
};

export default memo(Pagination);
